module.exports = __webpack_public_path__ + "img/az_logo@2x.6aa18c56.png";